import { FilterData } from 'path-shared/models/filter-data';
import { SortDirection } from '@angular/material';
import { Instituciones } from 'path-shared/models/instituciones';


export class TramitarExOlotFilter extends FilterData {
  Id_Instit: string;

    constructor(sortField: string, sortDir: SortDirection) {
      super(sortField, sortDir);            
    }
  }
  